/* Dieses Ding hier ist für das Wechseln der Sprache zuständig.
 * Da es bisher nur 2 Sprachen gibt, und dazu noch nur relativ
 * wenige Sprachtexte, wird auf ein automatisches Nachladen
 * verzichtet.
 */

import { updateIntl } from "react-intl-redux";

/* Englisch ist sowieso immer mit dabei, für Deutsch (und evtl.
 * folgende Sprachen) müssen Locale-Daten von react-intl
 * vorhanden sein. Auch hier wird erstmal auf ein automatisches
 * Nachladen verzichtet.
 */
import { addLocaleData } from "react-intl";
import de_locale from "react-intl/locale-data/de";
addLocaleData([...de_locale]);

const messages = {
	/* ESLint mag require() hier nicht, funktioniert aber! */
	/* eslint-disable no-undef */
	de: require("./de_DE.json"),
	en: require("./en_GB.json")
	/* eslint-enable */
};

const gen_locale = (name, key, index) => ({
	locale: name,
	messages: messages[name],
	/* Diese Eigenschaft ist nicht für react-intl, sondern
		* für das DropDown in der Kopfzeile notwendig.
		* -> welcher Text soll für die Anzeige im DropDown für
		*	eine locale verwendet werden.
		*/
	i18n_key: key,
	/* Für Index siehe die Reihenfolge der Sprachen im Ablauf, textdef.c */
	index_in_ablauf: index
});

/* Das Dropdown in der Kopfzeile erstellt seinen Inhalt aufgrund
 * dieses Arrays.
 */
export const availableLocales = [
	gen_locale("de", "Deutsch", 1),
	gen_locale("en", "English", 0)
];

const getLocale = locale_name => (
	availableLocales.find(item => {
		return item.locale === locale_name;
	})
);

export const getDecimalSeperator = (currentLocale) => {
	if(currentLocale === "de") {
		return ",";
	}
	else {
		return ".";
	}
}

export const getLocaleByIndex = index => (
	availableLocales.find(item => {
		return item.index_in_ablauf === index;
	})
);

export const getLocaleByI18nKey = key => (
	availableLocales.find(item => {
		return item.i18n_key === key;
	})
);

/* Erste Sprache, wird für initialState bei createStore() verwendet */
export const defaultLocale = availableLocales[0];

const newLocale = locale_i18n_key => ({
	type: "NEW_LOCALE",
	i18n_key: locale_i18n_key
});

export const localeReducer = (state = defaultLocale.i18n_key, action) => {
	switch (action.type) {
	case "NEW_LOCALE":
		return action.i18n_key;
	default:
		break;
	}
	return state;
};

/* Diese Funktion nutzen um einen Sprachwechsel einzuleiten. Da ja
 * bisher alle Sprachtexte gleich mitgeladen werden, kann sofort
 * umgeschaltet werden.
 */
export function switchLocale(locale_name, dispatch) {
	let locale = getLocale(locale_name);
	dispatch(updateIntl(locale));
	dispatch(newLocale(locale.i18n_key));
}
